import React, { Component } from "react";
import DocumentAdmin from "../../../components/DocumentAdmin/DocumentAdmin";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : OvertimeForm
Description : Componente que invoca al componente Overtime, para la consulta y creación de horas extra.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Overtime
================================================================================ */
class DocumentAdminForm extends Component {
    render() {
        return (
            <DocumentAdmin />
        )
    }
}

export default DocumentAdminForm;
